<template>
  <TopProgressBar />
  <router-view></router-view>
</template>
<style>
.swal2-container {
  z-index: 200000 !important;
}
</style>
<script setup>
import { onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
import { useAuthStore } from "@/stores/auth";
import TopProgressBar from "@/components/TopProgressBar.vue";

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_BACKEND_API_URL;

const route = useRoute();
const authStore = useAuthStore();

let validating = false;
let lastValidationAt = 0;
const validationCooldownMs = 30000;

const isAuthRoute = () => {
  const path = route.path || window.location.pathname;
  return path.startsWith("/auth/callback") || path.startsWith("/login") || path.startsWith("/logout");
};

const validateTokenWithServer = async (force = false) => {
  if (isAuthRoute()) return;
  // Jika hak akses sudah ter-load oleh router.beforeEach dan bukan trigger revalidasi paksa, hindari request ganda
  if (!force && authStore.isPrivilegesLoaded) return;
  if (validating) return;
  if (Date.now() - lastValidationAt < validationCooldownMs) return;

  validating = true;

  try {
    // Gunakan fungsi terpusat fetchMe dari auth store (dilengkapi deduplikasi promise)
    await authStore.fetchMe(force);
  } catch (error) {
    console.warn("Validasi sesi server:", error?.response?.status || error.message);
  } finally {
    validating = false;
  }
};

onMounted(() => {
  // Panggil validasi hanya jika sesi belum ter-load oleh router middleware
  validateTokenWithServer(false);

  document.addEventListener("visibilitychange", handleVisibilityChange);
});

onUnmounted(() => {
  document.removeEventListener("visibilitychange", handleVisibilityChange);
});

const handleVisibilityChange = () => {
  if (document.visibilityState === "visible") {
    // Saat user kembali ke tab browser, lakukan revalidasi sesi
    validateTokenWithServer(true);
  }
};
</script>
